<template>
	 <v-container>
		 <v-dialog title="绑定家长手机号" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>绑定家长登录手机号</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-card-text class="mt-4">
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="学员姓名" v-model="studentName" disabled dense outlined>
							</v-text-field>
						</v-col>
			
						<v-col cols="12">
							<v-text-field label="家长登录手机号" v-model="add.appUserMobile" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitBind" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	export default {
		name:"bind-parent-mobile",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			studentId:{
				type:String,
				default:""
			},
			studentName:{
				type:String,
				default:""
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
			}
		},
		data(){
			return {
				add: {
					appUserMobile:""
				},
				
				hideShow:this.show
			}
		},
		mounted() {
			console.log("bind-parent-mobile mounted");
		},
		methods:{
			
			cancel(){
				this.$emit("cancel","");
			},
			submitBind() {
				if(!this.studentId){
					this.$noty.error('缺少参数');
					return
				}
				if (!this.add.appUserMobile) {
					this.$noty.error('请输入家长登录手机号');
					return
				}
			
				// api
				const that = this;
				let url = `/edu/student/app/user/bind`;
			
				// parameters
				const studentId = this.studentId;
				const mobile = this.add.appUserMobile;
				const postData = {
					studentId: studentId,
					appUserMobile: mobile,
				}
				console.log(postData);
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("绑定成功");
							that.$emit("success",{mobile:that.add.appUserMobile});
			
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			},
		}
	}
	
</script>

<style>
</style>
